module.exports = __webpack_public_path__ + "img/hover-linked-in.38f0a019.svg";